// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"b6bcaa43","148":"957e32fb","188":"859f454e","358":"88e6575a","415":"99e928c6","478":"b5d92f1c","659":"a7037464","945":"3edd813d"}[chunkId] + ".chunk.css";
};